<template>
  <div class="member-info-container" v-if="member">
    <div class="member-info-header px-3">
      <h5 class="title my-0">
        {{ $t("feature.member.house_number") }}
        <span>{{ member.addressNo }}</span>
      </h5>
      <div>
        <span>{{ countOwner }} {{ $t("owner.proprietor") }}</span>
        <span v-if="countResident > 0"
          >{{ countResident }} {{ $t("owner.resident") }}</span
        >
        <span v-if="countRenter > 0"
          >{{ countRenter }} {{ $t("owner.renter") }}</span
        >
      </div>
    </div>
    <div class="members">
      <div class="member-group">
        <h2 class="title px-3">
          {{ $t("owner.proprietor") }} {{ countOwner }} {{ $t("unit.people") }}
        </h2>
        <people
          v-for="(people, index) in owners"
          :key="index"
          :people="people"
          role="owner"
          @new-message="onNewMessage"
          :showGreeting="true"
        />
      </div>
      <div class="member-group" v-show="countResident > 0">
        <h2 class="title px-3">
          {{ $t("owner.resident") }} {{ countResident }} {{ $t("unit.people") }}
        </h2>
        <people
          v-for="(people, index) in residents"
          :key="index"
          :people="people"
          role="resident"
          @new-message="onNewMessage"
        />
      </div>
      <div class="member-group" v-show="countRenter > 0">
        <h2 class="title px-3">
          {{ $t("owner.renter") }} {{ countRenter }} {{ $t("unit.people") }}
        </h2>
        <people
          v-for="(people, index) in renters"
          :key="index"
          :people="people"
          role="renter"
          @new-message="onNewMessage"
        />
      </div>
    </div>
    <div class="">
      <reply-box
        v-if="showReplyBox && selectedContactId"
        :contact-id="selectedContactId"
        :projectId="projectId"
        :homeId="homeId"
        :title="replyBoxTitle"
        @message-close="onMessageBoxClose"
        type="greeting"
        @message-send-success="onMessageSendSuccess"
        @message-send-fail="onMessageSendFail"
      ></reply-box>
    </div>
  </div>
</template>

<script>
import People from "./People";
import ReplyBox from "@/components/admin/view/contact/ReplyBox";

export default {
  props: {
    homeId: {},
    member: {}
  },
  components: {
    People,
    ReplyBox
  },
  data() {
    return {
      projectId: null,
      showReplyBox: false,
      selectedContactId: null,
      replyBoxTitle: null
    };
  },
  computed: {
    countOwner() {
      return this.member.owners.length || 0;
    },
    countResident() {
      return this.member.residents.length || 0;
    },
    countRenter() {
      return this.member.renters.length || 0;
    },
    owners() {
      return this.member.owners.sort(this.sortByName);
    },
    renters() {
      return this.member.renters.sort(this.sortByName);
    },
    residents() {
      return this.member.residents.sort(this.sortByName);
    }
  },
  methods: {
    sortByName(a, b) {
      if (a.firstname < b.firstname) {
        return -1;
      } else if (a.firstname > b.firstname) {
        return 1;
      }
      return 0;
    },
    onNewMessage(people, role) {
      this.projectId = localStorage.getItem("projectId");
      this.selectedContactId = people.userId;
      this.showReplyBox = true;
      this.replyBoxTitle = people.fullname;
    },
    onMessageSendSuccess({ topicId }) {
      this.$router.push({ name: "Contact", params: { contactId: topicId } });
    },
    onMessageSendFail(error) {},
    onMessageBoxClose() {
      this.selectedContactId = null;
      let projectId = null;
      this.showReplyBox = false;
      this.replyBoxTitle = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.member-info-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.member-info-header {
  border-bottom: 1px solid#e0e0e0;
  padding: 10px 0;
  h5 {
    font-size: 16px;
    font-weight: bold;
    span {
      font-size: 16px;
      font-weight: bold;
    }
  }
  span {
    color: #4a4a4a;
    font-size: 11px;
  }
}
.members {
  flex: 1;
  overflow: auto;
}
.member-group {
  .title {
    margin: 0;
    padding: 9px 0;
    font-size: 16px;
    font-weight: bold;
    background-color: #f9f9f9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/member/MemberInfo.vue